import { browserHistory } from 'react-router';

import { startApiRequest, endApiRequest } from '../loadingState/loadingStateActions';
import { openSuccessDialog, openErrorDialog } from '../dialog/dialogActions';
import { clearLoggedIn } from '../../lib/auth';

/**
 * Handles the 401 error condition by sending the user back to the login page
 * and displays a dialog letting the user know they have been logged out.
 *
 * @returns true if and only if the error type is 401 and false otherwise.
 */
const handle401Error = (dispatch, error) => {
  if (error.name === 401) {
    clearLoggedIn();

    if ("/" !== localStorage.logoutUrl) {
      window.location.href = localStorage.logoutUrl;
    } else {
      browserHistory.push('/');
      dispatch(openSuccessDialog({
        title: 'Logged Out',
        content: 'We logged you out due to inactivity in order to protect your health information.',
      }));
    }
    return true;
  }
  return false;
};

/**
 * Redux action to call an endpoint that does not require parameters.
 *
 * @param type The action type as defined by the Redux action.
 * @param api The Api endpoint. This is the function that will be called.
 * @param successCallback The callback that will be executed on successful execution of the request.
 * @param errorCallback The callback that will be executed on failure of the request.
 * @param useErrorDialog If this is set to true, then a standard error dialog will be shown.
 */
export const execApi = ({ type, api, successCallback, errorCallback, useErrorDialog, }) => {
  return dispatch => {
    dispatch(startApiRequest(type));

    api(response => {
      dispatch(endApiRequest(type));
      if (successCallback) {
        successCallback(response);
      }
      // @TODO response.successful false errorCallback here possibly to handle a "rejected" api status
    }, error => {
      dispatch(endApiRequest(type));
      if (handle401Error(dispatch, error)) return;
      if (useErrorDialog) {
        dispatch(openErrorDialog({
          title: error.message.title,
          content: error.message.body,
        }));
      }
      if (errorCallback) {
        errorCallback(error);
      }
    });
  }
};

/**
 * Redux action to call an endpoint that requires additional parameters.
 *
 * @param type The action type as defined by the Redux action.
 * @param api The Api endpoint. This is the function that will be called.
 * @param successCallback The callback that will be executed on successful execution of the request.
 * @param errorCallback The callback that will be executed on failure of the request.
 * @param useErrorDialog If this is set to true, then a standard error dialog will be shown.
 */
export const execApiWithParam = ({ type, api, successCallback, errorCallback, useErrorDialog, param, }) => {
  return dispatch => {
    dispatch(startApiRequest(type));

    api(param, response => {
      dispatch(endApiRequest(type));
      if (successCallback) {
        successCallback(response);
      }
    }, error => {
      dispatch(endApiRequest(type));
      if (handle401Error(dispatch, error)) return;
      if (useErrorDialog) {
        dispatch(openErrorDialog({
          title: error.message.title,
          content: error.message.body,
        }));
      }
      if (errorCallback) {
        errorCallback(error);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/api/apiActions.js